import React from 'react';
import { Counter } from '@fiverr-private/data_display';
import { I18n } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import { FormCounterProps } from '../types';
import { useFormContext } from '../FormContext';
import { FORM_COUNTER_ID } from '../constants';

const FormCounter = ({ maxLength, value = '', format }: FormCounterProps) => {
  const { value: formValue, maxLength: formMaxLength } = useFormContext();
  const stringValueLength = (formValue || value)?.toString().length;

  return (
    <Typography as="span" marginLeft="auto">
      <Counter current={stringValueLength} max={formMaxLength || maxLength} format={format} />
      &nbsp;
      <I18n k={'forms.formCounter.characters'} params={{ count: stringValueLength }} />
    </Typography>
  );
};

FormCounter.id = FORM_COUNTER_ID;
FormCounter.displayName = FORM_COUNTER_ID;

export default FormCounter;
